import React, { memo } from 'react'

// import Cases from '../../components/LeanC/Cases'
import Contact from '../../components/LeanC/Contact'
import Footer from '../../components/LeanC/Footer'
import Header from '../../components/LeanC/Header'
import Hero from '../../components/LeanC/Hero'
import Process from '../../components/LeanC/Process'
import Services from '../../components/LeanC/Services'

interface Props {}

const Index: React.FC<Props> = memo(() => {
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main-content">
        <Hero />
        <Services />
        <Process />
        {/* <Cases /> */}
        <Contact />
      </main>
      <Footer />
    </div>
  )
})
Index.displayName = 'Index'

export default Index
